module.exports = __webpack_public_path__ + "068152e55083911071f7fd2dd0ef8b2b.svg";